/**
 * Stable CSS class names for E2E — SCR risk paper (controls + history grid).
 */
export const SCRP = {
    page: 'scr-paper-page',
    controlsColumn: 'scr-paper-page__controls-column',
    switchRow: 'scr-paper-page__switch-row',
    inputSwitchRisk: 'scr-paper-input--switch-risk',
    inputTextareaReason: 'scr-paper-input--textarea-reason',
    actionsRow: 'scr-paper-page__actions-row',
    inputButtonSend: 'scr-paper-input--button-send',
    historyColumn: 'scr-paper-page__history-column',
    datagridWrap: 'scr-paper-page__datagrid-wrap',
    datagrid: 'scr-paper-page__datagrid',
} as const;

export const scrpCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
